import React, {PureComponent} from 'react';
import SessionTimeoutModal from './SessionTimeoutModal';
import SessionTimeoutOverlay from './SessionTimeoutOverlay';
import moment from 'moment';

const {setInterval, localStorage} = window;

const getHumanReadableTimeLeft = (sessionExpiresTimeIso: string, now = new Date()) => {
    const expiresTime = moment(sessionExpiresTimeIso);
    const timeLeft = expiresTime.diff(now);
    const oneHourMs = 60 * 60 * 1000;
    const modalTimeLeftFormat = timeLeft > oneHourMs ? 'HH [hours] mm [min] ss [sec]' : 'mm [min] ss [sec]';
    const overlayTimeLeftFormat = timeLeft > oneHourMs ? 'HH:mm:ss' : 'mm:ss';
    const timeLeftSpan = moment.utc(timeLeft);
    return {
        modalTimeLeft: timeLeftSpan.format(modalTimeLeftFormat),
        overlayTimeLeft: timeLeftSpan.format(overlayTimeLeftFormat),
    };
};

interface SessionTimeoutNotifierProps {
    warningTimeout: number;
    onSessionExpired: () => any;
}

interface SessionTimeoutNotifierState {
    expiresTimeIso: string | null;
    hasModalDisplayed: boolean;
    showModal: boolean;
    showOverlay: boolean;
    modalTimeLeft: string;
    overlayTimeLeft: string;
}

class SessionTimeoutNotifier extends PureComponent<SessionTimeoutNotifierProps, SessionTimeoutNotifierState> {
    timerId: number;

    constructor(props) {
        super(props);

        this.state = {
            expiresTimeIso: localStorage.getItem('sessionExpiresTime'),
            hasModalDisplayed: false,
            showModal: false,
            showOverlay: false,
            modalTimeLeft: '',
            overlayTimeLeft: '',
        };
    }

    componentDidMount() {
        this.timerId = setInterval(this.update, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timerId);
    }

    update = () => {
        const expiresTimeIso = localStorage.getItem('sessionExpiresTime');

        if (expiresTimeIso) {
            const now = new Date();
            const expiresTime = new Date(expiresTimeIso);

            // display the modal only if the session is about to expire and the modal hasn't been shown before
            if (!this.state.hasModalDisplayed) {
                const differenceInSeconds = (expiresTime.getTime() - now.getTime()) / 1000;
                if (this.props.warningTimeout > differenceInSeconds) {
                    this.setState({showModal: true, hasModalDisplayed: true});
                }
            }

            if (this.state.showModal || this.state.showOverlay) {
                this.setState(getHumanReadableTimeLeft(expiresTimeIso));
            }

            if (expiresTime < now) {
                clearInterval(this.timerId);
                this.props.onSessionExpired();
            }

            this.setState({expiresTimeIso});
        }
    }

    onCloseModal = () => this.setState({showModal: false, showOverlay: true});

    render() {
        const {expiresTimeIso} = this.state;

        if (!expiresTimeIso) {
            return <div></div>;
        }

        return <div>
            {this.state.showModal &&
                <SessionTimeoutModal timeLeft={this.state.modalTimeLeft} onClose={this.onCloseModal} />}
            {this.state.showOverlay && <SessionTimeoutOverlay timeLeft={this.state.overlayTimeLeft} />}
        </div>;
    }
}

export default SessionTimeoutNotifier;
